import { Text, Box, VStack, Button, Link } from '@chakra-ui/react'

import {
  logCTAEvent,
  logPreviewEvent,
} from '@/features/Courses/helpers/gtmEvent'

import { Course } from '@/features/Courses/types'

interface Props {
  course: Course
}

function TitleWidget({ course }: Props): React.ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        flexFlow: 'column nowrap',
        maxW: '543px',
        borderRadius: '12px',
        overflow: 'hidden',
        bg: 'primary.25',
        minH: '412px',
      }}
    >
      <VStack
        spacing="2"
        sx={{
          alignItems: 'stretch',
          px: { base: 4, md: 8 },
          py: { base: 3, md: 6 },
          flex: '1 1 auto',
        }}
      >
        <Text
          sx={{
            fontSize: {
              base: 'lg',
              sm: 'xl',
              md: '3xl',
            },
            color: 'primary.800',
            fontWeight: 'bold',
          }}
        >
          {course.title}
        </Text>
        <Text
          sx={{
            fontSize: {
              base: 'md',
              md: 'lg',
            },
            fontWeight: 'light',
            color: 'gray.700',
          }}
        >
          {course.subtitle}
        </Text>
        <Text
          sx={{
            mt: 2,
            fontSize: {
              base: 'xl',
              sm: '2xl',
              md: '3xl',
            },
            fontWeight: 'bold',
            color: 'primary.500',
            whiteSpace: 'nowrap',
          }}
        >
          {course.price}
        </Text>
        <VStack
          sx={{
            mt: 'auto !important',
          }}
        >
          <Button
            as={Link}
            isExternal
            href={course.coursePageLink}
            onClick={() => {
              logCTAEvent(course.slug)
            }}
            size="lg"
            sx={{
              textDecoration: 'none !important',
              mt: 4,
              w: 'full',
              h: '56px',
              fontSize: 'xl',
            }}
          >
            ชำระเงินเพื่อเริ่มเรียน
          </Button>
          {course.previewLink && (
            <Button
              as={Link}
              isExternal
              href={course.previewLink}
              variant="outline"
              size="lg"
              sx={{
                textDecoration: 'none !important',
                w: 'full',
                h: '56px',
                fontSize: 'xl',
              }}
              onClick={() => {
                logPreviewEvent(course.slug)
              }}
            >
              ทดลองเรียนฟรี !
            </Button>
          )}
        </VStack>
      </VStack>
    </Box>
  )
}

export default TitleWidget
